/**
 * JSON Stringify with circular reference replacer.
 *
 * @param    {Object}  obj  The incoming object
 * @returns  {string}  The JSON string
 */
module.exports = function circularSafeJSONStringify(obj) {
    return JSON.stringify(obj, getCircularReplacer());
};

/**
 * Create a new replacer.
 *
 * @returns  {function}  The replacer
 */
function getCircularReplacer() {
    var seenObjects = []; // Use an array to track seen objects

    return function(key, value) {
        if (typeof value === "object" && value !== null) {
            if (seenObjects.indexOf(value) !== -1) {
                // Circular reference found, can return undefined or modify as needed
                return "[Circular Reference]";
            }
            seenObjects.push(value); // Add value to list of seen objects
        }

        return value; // Return the value itself if it's not a circular reference
    };
}
